<template>
  <div>
    <div class="text-lg font-bold text-text leading-tight mb-6">{{ $t('connectedAccounts') }}</div>
    <div class="flex space-x-6">
      <UserConnectedAccountsItem v-for="(provider,i) in auth_accounts" :key="`provider-${i}`"
                                 :provider="provider"
                                 :providerName="i"
                                 @connect="submitted ? '':connect($event)"
                                 @disconnect="submitted ? '':disconnect($event)"/>
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import UserConnectedAccountsItem
  from "@/components/cabinet/ProfileSettings/UserConnectedAccounts/UserConnectedAccountsItem";

export default {
  name: "ConnectSocials",
  components: {UserConnectedAccountsItem},
  props: {
    auth_accounts: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      submitted: false
    }
  },
  methods: {
    ...mapActions('cabinet/user', ['connectSocialAccount', 'disconnectSocialAccount']),
    async connect(provider) {
      if (this.submitted) return;
      try {
        this.submitted = true;
        const res = await this.connectSocialAccount(provider)
        if (res.body.success) {
          window.location.href = res.body.data;
        } else {
          this.$toasted.error('Ошибка')
        }
      } catch (err) {
        console.error(err)
        this.$toasted.error('Ошибка')
      } finally {
        this.submitted = false;
      }
    },
    async disconnect(provider) {
      if (this.submitted) return;
      try {
        this.submitted = true;
        await this.disconnectSocialAccount(provider)
      } catch (err) {
        console.error(err)
        this.$toasted.error('Ошибка')
      } finally {
        this.submitted = false;
      }
    }
  },
  created() {
    if (this.$route.query.error === 'already_connected') {
      this.$toasted.error('Данный аккаунт уже подключен в нашей системе, не удалось привязать к вашему профилю')
      let query = Object.assign({}, this.$route.query);
      delete query.error;
      this.$router.replace({query});
    }
  },
  i18n: {
    messages: {
      en: {
        connectedAccounts: 'Connected accounts'
      },
      ru: {
        connectedAccounts: 'Связанные аккаунты'
      }
    }
  }
}
</script>